document.addEventListener("DOMContentLoaded", () => {
    const titles = document.querySelectorAll(".js-parallax-title");
    if (!titles.length) return;

    const elementsData = Array.from(titles).map(el => {
        return {
            el: el,
            maxMove: parseFloat(el.getAttribute("data-move-x")) || 100,
            currentX: 0,
            targetX: 0
        };
    });

    function animate() {
        elementsData.forEach(data => {
            data.currentX += (data.targetX - data.currentX) * 0.05;
            data.el.style.transform = `translateX(${data.currentX}px)`;
        });
        requestAnimationFrame(animate);
    }

    function onScroll() {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;

        elementsData.forEach(data => {
            const rect = data.el.getBoundingClientRect();
            
            const absoluteY = scrollY + rect.top;
            
            let startScrollY = absoluteY - viewportHeight;
            if (startScrollY < 0) startScrollY = 0; 

            let scrolled = scrollY - startScrollY;
            if (scrolled < 0) scrolled = 0;

            let factor = scrolled / viewportHeight;
            if (factor > 1) factor = 1;

            data.targetX = factor * data.maxMove;
        });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    
    onScroll(); 
    animate();
});